<template>
  <section class="skills">
    <div class="container">
      <h2 class="section-heading">Skills</h2>
<div class="skills-container">
  <div v-for="(skill,index) in skills" :key="index" class="skill">
    <img :src="require(`../../assets/imgs/${skill.img}.svg`)" :alt=skill.name class="skill-img">
    <p class="skill-name">{{skill.name}}</p>

  </div>
</div>


    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
export default {
  computed:{
    ...mapGetters(['skills'])
  }
}
</script>

<style scoped>
  .skills {
    padding-top: 0px;
  }
  .skills-container{
    margin-top:60px ;
    display: grid;
    grid-template-columns: repeat(5,1fr);
    justify-items: center;
    row-gap: 40px;
   width: 100%;

 
  }
  .skill{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   
  }
  .skill-img{
    filter: grayscale(100);
  }
  .skill-img:hover{
    filter: grayscale(0);
  }
  .skill-name{
    
    margin-top: 5px;
    font-size: 1.1em;
  }
  @media only screen and (max-width:480px){
    .skills-container{
    grid-template-columns: repeat(4,1fr);
  }
  }
</style>
